import {
  Badge,
  Box,
  Button,
  ComboboxItem,
  Flex,
  Grid,
  Loader,
  LoadingOverlay,
  MultiSelect,
  Select,
  Text,
  TextInput,
  Title,
} from "@mantine/core";
import { DatePickerInput } from "@mantine/dates";
import { useDebouncedState, useDisclosure, useHotkeys } from "@mantine/hooks";
import {
  IconBookmark,
  IconBrandBootstrap,
  IconCalendar,
  IconFileTypeCsv,
  IconSearch,
  IconUser,
  IconUserCode,
  IconUserEdit,
} from "@tabler/icons-react";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_RowSelectionState,
  useMantineReactTable,
} from "mantine-react-table";
import React, { useDeferredValue, useEffect, useState } from "react";
import { repositoryMdm } from "../../../../_base/_const/_constVar";
import _breadcrumb from "../../../../_base/component/_layout/_breadcrumb";
import { NotificationExtension } from "../../../../_base/extension/NotificationExtension";
import {
  changeSearchValue,
  getValueById,
} from "../../../../_base/helper/FunctionHelper";
import { formatDateTransfer } from "../../../../common/FormatDate/FormatDate";
import { BASE_API_MDM } from "../../../../config";
import { _localization } from "../../../../config/location";
import { MessageResponse } from "../../../../model/MessageResponse";
import {
  getMasterOrgSelect,
  getTblDepartmentSelect,
  getTblDmCustomerGroupSelect,
} from "../../../../service/getSelectApi";

type ColumnPinningType = {
  left?: string[];
  right?: string[];
};
type Props = {
  itemNV?: string;
};
const SalesRevenueReportV2 = ({ itemNV }: Props) => {
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [data, setData] = useState<any[]>([]);
  const [dataSum, setDataSum] = useState<any>({});
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [height, setHeight] = useState(0);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 20,
  });
  const rowSelectionDeferred =
    useDeferredValue<MRT_RowSelectionState>(rowSelection);
  const [selectIds, setSelectIds] = useState<string[]>([]);
  const [visible, { toggle, open, close }] = useDisclosure(false);
  const [isCallFirst, setIsCallFirst] = useState<boolean>(
    itemNV ? true : false,
  );

  const location = window.location;
  const _searchJson = sessionStorage.getItem(String(location?.pathname))
    ? JSON.parse(sessionStorage.getItem(String(location?.pathname)) ?? "")
    : null;
  const checkedPinSearch = localStorage.getItem("checkedPinSearch") == "true";
  const [search, setSearch] = useState<any>({
    FromDate:
      _searchJson && checkedPinSearch
        ? _searchJson?.FromDate
        : new Date(
            new Date(new Date().setMonth(new Date().getMonth() - 1)).getTime() +
              7 * 3600 * 1000,
          )?.toISOString(),
    ToDate:
      _searchJson && checkedPinSearch
        ? _searchJson?.ToDate
        : new Date(new Date().getTime() + 7 * 3600 * 1000).toISOString(),
    MaCn: _searchJson && checkedPinSearch ? _searchJson?.MaCn : [],
    MaBp: _searchJson && checkedPinSearch ? _searchJson?.MaBp : "",
  });
  const [keySearch, setKeySearch] = useDebouncedState<string>(
    _searchJson && checkedPinSearch ? _searchJson?.keySearch : "",
    300,
  );

  const [MaNvhs, setMaNvhs] = useDebouncedState<string>(
    itemNV
      ? itemNV.trim()
      : _searchJson && checkedPinSearch
        ? _searchJson?.MaNvhs
        : "",
    300,
  );
  const [MaKh, setMaKh] = useDebouncedState<string>(
    _searchJson && checkedPinSearch ? _searchJson?.MaKh : "",
    300,
  );
  const [TenKh, setTenKh] = useDebouncedState<string>(
    _searchJson && checkedPinSearch ? _searchJson?.TenKh : "",
    300,
  );

  const [dataBranchSelect, setDataBranchSelect] = useState<ComboboxItem[]>([]);
  const [dataDepartmentSelect, setDataDepartmentSelect] = useState<
    ComboboxItem[]
  >([]);
  const [dataCustomerGroupSelect, setDataCustomerGroupSelect] = useState<
    ComboboxItem[]
  >([]);
  const dataStatusGeneral = [
    { label: "Kho xuất hàng", value: "KHO_XUAT_HANG" },
    { label: "Thành công", value: "THANH_CONG" },
    { label: "Test OK", value: "TEST_OK" },
    { label: "Đơn hàng hoàn thành", value: "DON_HANG_HOAN_THANH" },
    { label: "Đơn hàng tạm", value: "DON_HANG_TAM" },
    { label: "Thất bại do KH", value: "THAT_BAI_DO_KH" },
    { label: "KTKT đang kiểm tra", value: "KTKT_DANG_KIEM_TRA" },
    { label: "Đơn hàng chờ duyệt giảm", value: "DON_HANG_CHO_DUYET_GIAM" },
    { label: "Đơn chờ duyệt đổi trả", value: "DON_CHO_DUYET_DOI_TRA" },
    { label: "Đơn đã duyệt đổi trả", value: "DON_DA_DUYET_DOI_TRA" },
    { label: "GV thành công", value: "GV_THANH_CONG" },
    { label: "Nhập lại", value: "NHAP_LAI" },
    { label: "Đã phân công GV", value: "DA_PHAN_CONG_GV" },
    { label: "GV đến nơi", value: "GV_DEN_NOI" },
    { label: "GV đang giao", value: "GV_DANG_GIAO" },
    { label: "Test lỗi", value: "TEST_LOI" },
    { label: "Đã phân công KTKT", value: "DA_PHAN_CONG_KTKT" },
    { label: "Hủy phân công GV", value: "HUY_PHAN_CONG_GV" },
    { label: "Thất bại do HACOM", value: "THAT_BAI_DO_HACOM" },
    { label: "Nhập lại một phần", value: "NHAP_LAI_MOT_PHAN" },
    { label: "Đơn hàng chốt", value: "DON_HANG_CHOT" },
    { label: "Đơn hàng đã duyệt giảm", value: "DON_HANG_DA_DUYET_GIAM" },
    { label: "GV tiếp nhận", value: "GV_TIEP_NHAN" },
    { label: "GV nhập lại", value: "GV_NHAP_LAI" },
    { label: "GV nhập lại một phần", value: "GV_NHAP_LAI_MOT_PHAN" },
    { label: "GV thất bại do HACOM", value: "GV_THAT_BAI_DO_HACOM" },
    { label: "GV thất bại do KH", value: "GV_THAT_BAI_DO_KH" },
    { label: "GV nối chuyến", value: "GV_NOI_CHUYEN" },
    { label: "Hủy phân công KTKT", value: "HUY_PHAN_CONG_KTKT" },
    { label: "KH đã nhận", value: "DA_NHAN" },
  ];
  const warehouseStatus = [
    { value: "DA_YEU_CAU", label: "Đã yêu cầu" },
    { value: "DANG_XUAT", label: "Đang xuất" },
    { value: "DA_XUAT", label: "Đã xuất" },
    { value: "DANG_NHAP", label: "Đang nhập" },
    { value: "DA_NHAP", label: "Đã nhập" },
  ];

  const columns = React.useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        accessorKey: "soHd",
        header: "Mã đơn hàng",
        Cell: ({ renderedCellValue }) => (
          <Badge
            variant={renderedCellValue === "Tổng cộng" ? "filled" : "dot"}
            color={renderedCellValue ? "green" : "red"}
          >
            {renderedCellValue ? renderedCellValue : "Không xác định"}
          </Badge>
        ),
      },
      {
        accessorKey: "maCn",
        header: "Chi nhánh",
        Cell: ({ renderedCellValue }) => (
          <Text fw={500} size="12.5px">
            {getValueById(String(renderedCellValue), dataBranchSelect, "label")}
          </Text>
        ),
      },
      {
        accessorKey: "tenBp",
        header: "Tên bộ phận",
        Cell: ({ renderedCellValue, row }) =>
          renderedCellValue ? (
            <Text fw={500} size="12.5px">
              {row.original.maBp} - {renderedCellValue}
            </Text>
          ) : (
            <></>
          ),
      },
      {
        accessorKey: "maKh",
        header: "Mã khách hàng",
        Cell: ({ renderedCellValue }) =>
          renderedCellValue ? (
            <Badge variant="light">{renderedCellValue}</Badge>
          ) : (
            <></>
          ),
      },
      { accessorKey: "tenKh", header: "Tên khách hàng" },
      {
        accessorKey: "maDtcn",
        header: "Mã đối tượng công nợ",
        size: 225,
      },
      { accessorKey: "tenCongTy", header: "Tên công ty" },
      { accessorKey: "mst", header: "Mã số thuế" },
      { accessorKey: "soDt", header: "Số điện thoại" },
      {
        accessorKey: "nhomKh",
        header: "Nhóm khách hàng",
        Cell: ({ renderedCellValue }) => (
          <Text fw={500} size="12.5px">
            {getValueById(
              String(renderedCellValue),
              dataCustomerGroupSelect,
              "label",
            )}
          </Text>
        ),
      },
      {
        accessorKey: "phuongThucThanhToan",
        header: "Phương thức thanh toán",
        size: 225,
      },
      { accessorKey: "maVoucher", header: "Mã voucher" },
      {
        accessorKey: "ngayTao",
        header: "Ngày tạo",
        Cell: ({ renderedCellValue }: any) => (
          <Text size="12.5px" fw={"500"}>
            {renderedCellValue && formatDateTransfer(renderedCellValue)}
          </Text>
        ),
      },
      {
        accessorKey: "ngayHachToan",
        header: "Ngày hạch toán",
        Cell: ({ renderedCellValue }: any) => (
          <Text size="12.5px" fw={"500"}>
            {renderedCellValue && formatDateTransfer(renderedCellValue)}
          </Text>
        ),
      },
      {
        accessorKey: "trangThaiChung",
        header: "Trạng thái chung",
        Cell: ({ renderedCellValue }) =>
          renderedCellValue ? (
            <Badge color="cyan">
              {getValueById(
                renderedCellValue?.toString() ?? "",
                dataStatusGeneral,
                "label",
              )?.toUpperCase()}
            </Badge>
          ) : (
            <></>
          ),
        size: 200,
      },
      {
        accessorKey: "trangThaiXuatKho",
        header: "Trạng thái xuất kho",
        Cell: ({ renderedCellValue }) =>
          renderedCellValue ? (
            <Badge color="cyan">
              {getValueById(
                renderedCellValue?.toString() ?? "",
                warehouseStatus,
                "label",
              )?.toUpperCase()}
            </Badge>
          ) : (
            <></>
          ),
      },
      {
        accessorKey: "bpGiaoHang",
        header: "Bộ phận giao hàng",
      },
      {
        accessorKey: "ttGiaoHang",
        header: "Trạng thái giao hàng",
        Cell: ({ renderedCellValue }) =>
          renderedCellValue ? (
            <Text fw={500} size="12.5px">
              {getValueById(
                String(renderedCellValue),
                dataStatusGeneral,
                "label",
              ) || renderedCellValue}
            </Text>
          ) : (
            <></>
          ),
        size: 225,
      },
      { accessorKey: "nguoiTao", header: "Người tạo" },
      { accessorKey: "nguoiHuongSo", header: "Người hưởng số" },
      { accessorKey: "maBoPc", header: "Mã bộ PC" },
      {
        accessorKey: "tienDonHang",
        header: "Tiền đơn hàng",
        Cell: ({ renderedCellValue, row }) =>
          renderedCellValue || renderedCellValue === 0 ? (
            <Text
              fw={500}
              size="12.5px"
              c={
                row.original.soHd === "Tổng cộng" &&
                Number(renderedCellValue) > 0
                  ? "green"
                  : row.original.soHd === "Tổng cộng" &&
                      Number(renderedCellValue) < 0
                    ? "red"
                    : "black"
              }
            >
              {Number(renderedCellValue).toLocaleString()} VNĐ
            </Text>
          ) : (
            <></>
          ),
      },
      {
        accessorKey: "tienCk",
        header: "Tiền chiết khấu",
        Cell: ({ renderedCellValue, row }) =>
          renderedCellValue || renderedCellValue === 0 ? (
            <Text
              fw={500}
              size="12.5px"
              c={
                row.original.soHd === "Tổng cộng" &&
                Number(renderedCellValue) > 0
                  ? "green"
                  : row.original.soHd === "Tổng cộng" &&
                      Number(renderedCellValue) < 0
                    ? "red"
                    : "black"
              }
            >
              {Number(renderedCellValue).toLocaleString()} VNĐ
            </Text>
          ) : (
            <></>
          ),
      },
      {
        accessorKey: "tienGg",
        header: "Tiền giảm giá",
        Cell: ({ renderedCellValue, row }) =>
          renderedCellValue || renderedCellValue === 0 ? (
            <Text
              fw={500}
              size="12.5px"
              c={
                row.original.soHd === "Tổng cộng" &&
                Number(renderedCellValue) > 0
                  ? "green"
                  : row.original.soHd === "Tổng cộng" &&
                      Number(renderedCellValue) < 0
                    ? "red"
                    : "black"
              }
            >
              {Number(renderedCellValue).toLocaleString()} VNĐ
            </Text>
          ) : (
            <></>
          ),
      },
      {
        accessorKey: "tienCkGg",
        header: "Tiền CK giảm giá",
        Cell: ({ renderedCellValue, row }) =>
          renderedCellValue || renderedCellValue === 0 ? (
            <Text
              fw={500}
              size="12.5px"
              c={
                row.original.soHd === "Tổng cộng" &&
                Number(renderedCellValue) > 0
                  ? "green"
                  : row.original.soHd === "Tổng cộng" &&
                      Number(renderedCellValue) < 0
                    ? "red"
                    : "black"
              }
            >
              {Number(renderedCellValue).toLocaleString()} VNĐ
            </Text>
          ) : (
            <></>
          ),
      },
      {
        accessorKey: "tienSauCkGg",
        header: "Tiền sau CK giảm giá",
        size: 225,
        Cell: ({ renderedCellValue, row }) =>
          renderedCellValue || renderedCellValue === 0 ? (
            <Text
              fw={500}
              size="12.5px"
              c={
                row.original.soHd === "Tổng cộng" &&
                Number(renderedCellValue) > 0
                  ? "green"
                  : row.original.soHd === "Tổng cộng" &&
                      Number(renderedCellValue) < 0
                    ? "red"
                    : "black"
              }
            >
              {Number(renderedCellValue).toLocaleString()} VNĐ
            </Text>
          ) : (
            <></>
          ),
      },
      {
        accessorKey: "tienVon",
        header: "Tiền vốn",
        Cell: ({ renderedCellValue, row }) =>
          renderedCellValue || renderedCellValue === 0 ? (
            <Text
              fw={500}
              size="12.5px"
              c={
                row.original.soHd === "Tổng cộng" &&
                Number(renderedCellValue) > 0
                  ? "green"
                  : row.original.soHd === "Tổng cộng" &&
                      Number(renderedCellValue) < 0
                    ? "red"
                    : "black"
              }
            >
              {Number(renderedCellValue).toLocaleString()} VNĐ
            </Text>
          ) : (
            <></>
          ),
      },
      {
        accessorKey: "tienLai",
        header: "Tiền lãi",
        Cell: ({ renderedCellValue, row }) =>
          renderedCellValue || renderedCellValue === 0 ? (
            <Text
              fw={500}
              size="12.5px"
              c={
                row.original.soHd === "Tổng cộng" &&
                Number(renderedCellValue) > 0
                  ? "green"
                  : row.original.soHd === "Tổng cộng" &&
                      Number(renderedCellValue) < 0
                    ? "red"
                    : "black"
              }
            >
              {Number(renderedCellValue).toLocaleString()} VNĐ
            </Text>
          ) : (
            <></>
          ),
      },
      {
        accessorKey: "tienDaTra",
        header: "Tiền đã trả",
        Cell: ({ renderedCellValue, row }) =>
          renderedCellValue || renderedCellValue === 0 ? (
            <Text
              fw={500}
              size="12.5px"
              c={
                row.original.soHd === "Tổng cộng" &&
                Number(renderedCellValue) > 0
                  ? "green"
                  : row.original.soHd === "Tổng cộng" &&
                      Number(renderedCellValue) < 0
                    ? "red"
                    : "black"
              }
            >
              {Number(renderedCellValue).toLocaleString()} VNĐ
            </Text>
          ) : (
            <></>
          ),
      },
      {
        accessorKey: "conNo",
        header: "Còn nợ",
        Cell: ({ renderedCellValue, row }) =>
          renderedCellValue || renderedCellValue === 0 ? (
            <Text
              fw={500}
              size="12.5px"
              c={
                row.original.soHd === "Tổng cộng" &&
                Number(renderedCellValue) > 0
                  ? "green"
                  : row.original.soHd === "Tổng cộng" &&
                      Number(renderedCellValue) < 0
                    ? "red"
                    : "black"
              }
            >
              {Number(renderedCellValue).toLocaleString()} VNĐ
            </Text>
          ) : (
            <></>
          ),
      },
      { accessorKey: "maNhom", header: "Mã nhóm" },
      { accessorKey: "tenNhom", header: "Tên nhóm" },
      { accessorKey: "kenhBan", header: "Kênh bán" },
      {
        accessorKey: "tenTinh",
        header: "Tỉnh/Thành phố",
      },
      {
        accessorKey: "tenPhuongXa",
        header: "Phường/Xã",
      },
      {
        accessorKey: "diaChi",
        header: "Địa chỉ cụ thể",
      },
    ],
    [
      dataBranchSelect,
      dataCustomerGroupSelect,
      dataStatusGeneral,
      warehouseStatus,
    ],
  );

  const fetchData = async () => {
    const fromDate = new Date(search.FromDate);
    const toDate = new Date(search.ToDate);

    const maxAllowedDate = new Date(fromDate);
    maxAllowedDate.setMonth(fromDate.getMonth() + 12);

    if (toDate > maxAllowedDate) {
      NotificationExtension.Fails("Chỉ được phép lọc dữ liệu trong 1 năm !");
    } else {
      setIsLoading(true);
      setIsRefetching(true);
      setIsError(false);
      try {
        let url = `api/v1/VSaleOrderBy/get-list-v2?Skip=${
          pagination.pageIndex * pagination.pageSize
        }&Take=${pagination.pageSize}`;

        const params = new URLSearchParams();
        Object.entries(search).forEach(([key, value]) => {
          if (Array.isArray(value) && value.length > 0) {
            value.forEach((item) => params.append(key, String(item)));
          } else if (typeof value === "string" && value.length > 0) {
            params.append(key, value);
          }
        });

        if (keySearch.length > 0) {
          url += `&KeySearch=${keySearch?.trim()}`;
        }

        if (MaNvhs && MaNvhs.length > 0) {
          url += `&MaNvhs=${MaNvhs?.trim()}`;
        }

        if (MaKh.length > 0) {
          url += `&MaKh=${MaKh?.trim()}`;
        }

        if (TenKh.length > 0) {
          url += `&TenKh=${TenKh?.trim()}`;
        }

        url += `&${params.toString()}`;

        const res = await repositoryMdm.get<MessageResponse<any>>(url);

        if (res && res.success) {
          const result = res.data;
          setData(result);
          setRowCount(res.totalCount);
          setIsCallFirst(true);
          getDataSum(result);
        } else {
          setData([]);
        }
      } catch (error) {
        setData([]);
        setIsError(true);
        console.error(error);
        return;
      } finally {
        setIsLoading(false);
        setIsRefetching(false);
        sessionStorage.setItem(
          String(location?.pathname),
          JSON.stringify({
            ...search,
            keySearch: keySearch,
            MaKh: MaKh,
            TenKh: TenKh,
          }),
        );
      }
    }
  };

  const getDataSum = async (data: any[]) => {
    setIsLoading(true);
    setIsRefetching(true);
    setIsError(false);
    try {
      let url = `/api/v1/VSaleOrderBy/get-total-amount?Skip=${
        pagination.pageIndex * pagination.pageSize
      }&Take=${pagination.pageSize}`;

      const params = new URLSearchParams();
      Object.entries(search).forEach(([key, value]) => {
        if (Array.isArray(value) && value.length > 0) {
          value.forEach((item) => params.append(key, String(item)));
        } else if (typeof value === "string" && value.length > 0) {
          params.append(key, value);
        }
      });

      if (keySearch.length > 0) {
        url += `&KeySearch=${keySearch?.trim()}`;
      }

      if (MaNvhs && MaNvhs.length > 0) {
        url += `&MaNvhs=${MaNvhs?.trim()}`;
      }

      if (MaKh.length > 0) {
        url += `&MaKh=${MaKh?.trim()}`;
      }

      if (TenKh.length > 0) {
        url += `&TenKh=${TenKh?.trim()}`;
      }

      url += `&${params.toString()}`;

      const res = await repositoryMdm.get<MessageResponse<any>>(url);

      if (res && res.success) {
        const result = res.data;
        const dataSet = data.filter((item) => item.soHd !== "Tổng cộng");
        setData([{ ...result, soHd: "Tổng cộng" }, ...dataSet]);
        setDataSum(result);
      } else {
        setData([]);
      }
    } catch (error) {
      setData([]);
      setIsError(true);
      console.error(error);
      return;
    } finally {
      setIsLoading(false);
      setIsRefetching(false);
    }
  };

  const exportDataExcel = async () => {
    const fromDate = new Date(search.FromDate);
    const toDate = new Date(search.ToDate);

    const maxAllowedDate = new Date(fromDate);
    maxAllowedDate.setMonth(fromDate.getMonth() + 12);

    if (toDate > maxAllowedDate) {
      NotificationExtension.Fails("Chỉ được phép export excel trong 1 năm !");
    } else {
      open();
      try {
        let url = `?Skip=${pagination?.pageIndex}&Take=${pagination.pageSize}`;

        const params = new URLSearchParams();
        Object.entries(search).forEach(([key, value]) => {
          if (Array.isArray(value) && value.length > 0) {
            value.forEach((item) => params.append(key, String(item)));
          } else if (typeof value === "string" && value.length > 0) {
            params.append(key, value);
          }
        });

        if (keySearch.length > 0) {
          url += `&KeySearch=${keySearch?.trim()}`;
        }

        if (MaKh.length > 0) {
          url += `&MaKh=${MaKh?.trim()}`;
        }

        if (TenKh.length > 0) {
          url += `&TenKh=${TenKh?.trim()}`;
        }

        url += `&${params.toString()}`;

        const baseUrl = `/api/v1/ExportExcel/export-doanh-thu-ban-hang-v2${url}`;

        const _url = BASE_API_MDM + baseUrl;
        const token = localStorage.getItem("token");

        const response = await fetch(_url, {
          method: "GET",
          headers: {
            "Content-Type": "application/vnd.ms-excel",
            Authorization: `Bearer ${token?.replace(`"`, "").replace(`"`, "")}`,
          },
        });

        if (!response.ok) {
          NotificationExtension.Fails("Export Excel thất bại !");
        } else {
          const blob = await response.blob();
          const urlss = window.URL.createObjectURL(blob);
          const _name = new Date().toISOString().slice(0, 10);
          let filename = "bao_cao_doanh_so_tinh_luong_hang_thang.xlsx";
          const link = document.createElement("a");
          link.href = urlss;
          link.download = filename;
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(url);
          NotificationExtension.Success("Export Excel thành công !");
        }
      } catch (error) {
        console.log(error);
      } finally {
        close();
      }
    }
  };

  const getDataBranchSelect = async () => {
    const res = await getMasterOrgSelect();

    if (res) {
      const data = res
        ?.filter((item) => item.text && item.value)
        ?.map((item) => ({
          label: `${item.att1} - ${item.text}`,
          value: String(item.att1),
        }));

      setDataBranchSelect(data);
    }
  };

  const getDataDepartmentSelect = async () => {
    const res = await getTblDepartmentSelect();

    if (res) {
      const data = Array.from(
        new Map(
          res
            ?.filter((item) => item.text && item.att1)
            ?.map((item) => [
              String(item.att1),
              {
                label: `${item.text}`,
                value: String(item.att1),
              },
            ]),
        ).values(),
      );
      setDataDepartmentSelect(data);
    }
  };

  const getDataCustomerGroupSelect = async () => {
    const res = await getTblDmCustomerGroupSelect();

    if (res) {
      const data = Array.from(
        new Map(
          res
            ?.filter((item) => item.text && item.value)
            ?.map((item) => [
              String(item.value),
              {
                label: `${item.text}`,
                value: String(item.value),
              },
            ]),
        ).values(),
      );
      setDataCustomerGroupSelect(data);
    }
  };

  useEffect(() => {
    if (isCallFirst) {
      fetchData();
    }
  }, [pagination?.pageIndex, pagination?.pageSize]);

  useEffect(() => {
    Promise.all([
      getDataBranchSelect(),
      getDataDepartmentSelect(),
      getDataCustomerGroupSelect(),
    ]);
  }, []);

  const getColumnPinningStorage = () => {
    const columnPinningStorage = localStorage.getItem(
      "columnPinningSalesRevenueReport",
    );
    return columnPinningStorage
      ? JSON.parse(columnPinningStorage)
      : {
          left: ["mrt-row-select"],
          right: ["action"],
        }; // Giá trị mặc định
  };

  // Lưu columnPinning vào state
  const [columnPinning, setColumnPinning] = useState<ColumnPinningType>(
    getColumnPinningStorage(),
  );
  // Hàm lưu vào localStorage
  useEffect(() => {
    localStorage.setItem(
      "columnPinningSalesRevenueReport",
      JSON.stringify(columnPinning),
    );
  }, [columnPinning]);

  useEffect(() => {
    //   startTransition(() => {
    const valuesList = Object.keys(rowSelectionDeferred);
    setSelectIds(valuesList);
    if (valuesList.length < 1) setSelectIds([]);
    else {
      const valuesList = Object.keys(rowSelectionDeferred);
      setSelectIds(valuesList);
    }
    //  });
  }, [rowSelectionDeferred]);

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      setHeight(window.innerHeight - (150 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const table = useMantineReactTable({
    columns,
    data,
    enableColumnResizing: false,
    positionToolbarAlertBanner: "bottom",
    enableRowNumbers: true,
    //add custom action buttons to top-left of top toolbar
    enableTopToolbar: false,
    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },
    localization: _localization,
    getRowId: (row) => row.id?.toString(),
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        // left: ["mrt-row-numbers", "maVt"],
        // right: ["action"],
        ...columnPinning,
      },
      columnVisibility: { id: true, phone: false, fax: false },
      density: "xs",
    },
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    manualPagination: true,
    onColumnPinningChange: (newState) => {
      setColumnPinning(newState);
    },
    onRowSelectionChange: setRowSelection,
    rowCount: rowCount,
    onPaginationChange: setPagination,
    mantineTableBodyCellProps: ({ row }) => ({
      style: {
        fontWeight: "500", //conditional styling
        fontSize: "12.5px",
        padding: "5px 15px",
      },
    }),
    state: {
      isLoading,
      pagination: pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading, //loading for the first time with no data
      rowSelection,
      columnPinning,
    },
    mantineToolbarAlertBannerProps: isError
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      rowsPerPageOptions: ["20", "50", "100"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
    columnFilterDisplayMode: "popover",
    mantineTableBodyRowProps: ({ row }) => ({
      style: { cursor: "pointer" },
    }),
  });

  useHotkeys([
    [
      "Enter",
      () => {
        fetchData();
      },
    ],
  ]);

  return (
    <div
      style={{
        minWidth: "1200px",
      }}
    >
      <div
        ref={headerRef}
        style={{
          width: "100%",
        }}
      >
        <LoadingOverlay
          visible={visible}
          zIndex={1000}
          overlayProps={{ radius: "sm", blur: 5 }}
          loaderProps={{
            children: (
              <Flex direction={"column"} align="center" gap="xs">
                <Loader type="dots" size={35}></Loader>
                {/* <Title size={15}> Đang upload tài liệu...</Title> */}
                <Title size={15}> Đang xử lý....</Title>
              </Flex>
            ),
          }}
        />
        {itemNV ? (
          <></>
        ) : (
          <Flex justify={"space-between"} align={"center"} w={"100%"}>
            <_breadcrumb></_breadcrumb>
            <Flex gap={"md"}>
              <Button
                leftSection={<IconFileTypeCsv size={16} />}
                onClick={() => exportDataExcel()}
              >
                Export Excel
              </Button>
            </Flex>
          </Flex>
        )}
        <Grid mt={10} w={"100%"}>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <TextInput
              placeholder="Nhập từ khóa tìm kiếm"
              defaultValue={keySearch}
              onChange={(e) => setKeySearch(e.currentTarget.value)}
              leftSection={<IconSearch color="#15aabf" />}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  fetchData();
                }
              }}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <DatePickerInput
              size="sm"
              placeholder="Chọn ngày bắt đầu"
              locale="vi"
              valueFormat="DD/MM/YYYY"
              clearable
              value={
                search.FromDate && search.FromDate?.length > 0
                  ? new Date(search.FromDate ?? "")
                  : null
              }
              maxDate={
                search.ToDate && search.ToDate?.length > 0
                  ? new Date(search.ToDate)
                  : new Date()
              }
              onChange={(e) => {
                changeSearchValue(
                  e
                    ? new Date(
                        new Date(e).getTime() + 7 * 3600 * 1000,
                      )?.toISOString()
                    : "",
                  "FromDate",
                  setSearch,
                );
              }}
              leftSection={<IconCalendar color="#15aabf" />}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  fetchData();
                }
              }}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <DatePickerInput
              size="sm"
              placeholder="Chọn ngày kết thúc"
              locale="vi"
              valueFormat="DD/MM/YYYY"
              clearable
              value={
                search.ToDate && search.ToDate?.length > 0
                  ? new Date(search.ToDate ?? "")
                  : null
              }
              minDate={
                search.FromDate && search.FromDate?.length > 0
                  ? new Date(search.FromDate)
                  : undefined
              }
              onChange={(e) => {
                changeSearchValue(
                  e
                    ? new Date(
                        new Date(e).getTime() + 7 * 3600 * 1000,
                      )?.toISOString()
                    : "",
                  "ToDate",
                  setSearch,
                );
              }}
              leftSection={<IconCalendar color="#15aabf" />}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  fetchData();
                }
              }}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <TextInput
              placeholder="Nhập mã khách hàng"
              defaultValue={MaKh}
              onChange={(e) => setMaKh(e.currentTarget.value)}
              leftSection={<IconUserCode color="#15aabf" />}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  fetchData();
                }
              }}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <TextInput
              placeholder="Nhập tên khách hàng"
              defaultValue={TenKh}
              onChange={(e) => setTenKh(e.currentTarget.value)}
              leftSection={<IconUserEdit color="#15aabf" />}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  fetchData();
                }
              }}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <MultiSelect
              placeholder="Chi nhánh"
              data={dataBranchSelect}
              leftSection={<IconBrandBootstrap color="#15aabf" />}
              value={search.MaCn && search.MaCn?.length > 0 ? search.MaCn : []}
              searchable
              clearable
              nothingFoundMessage="Không tìm thấy dữ liệu !"
              onChange={(e) => changeSearchValue(e ? e : [], "MaCn", setSearch)}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <Select
              placeholder="Phòng ban"
              data={dataDepartmentSelect}
              leftSection={<IconBookmark color="#15aabf" />}
              value={search.MaBp && search.MaBp?.length > 0 ? search.MaBp : ""}
              searchable
              clearable
              nothingFoundMessage="Không tìm thấy dữ liệu !"
              onChange={(e) => changeSearchValue(e ? e : "", "MaBp", setSearch)}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <TextInput
              placeholder="Mã nhân viên hưởng số"
              defaultValue={MaNvhs}
              onChange={(e) => setMaNvhs(e.currentTarget.value)}
              leftSection={<IconUser color="#15aabf" />}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  fetchData();
                }
              }}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <Button
              onClick={() => {
                fetchData();
              }}
              leftSection={<IconSearch size={14} />}
            >
              Tìm kiếm
            </Button>
          </Grid.Col>
        </Grid>
      </div>
      <Box mt={10}>
        <MantineReactTable table={table} />
      </Box>
    </div>
  );
};

export default SalesRevenueReportV2;
